module.exports = __webpack_public_path__ + "media/tags/mass-1-ca41aeed.png";